import React from "react";
import NetworkError from "components/NetworkError/NetworkError";
import Header from "./Header";
import styles from "./FoodCourtLayout.module.css";

const FoodCourtLayout = ({ left, right, error, loading, goBack = null }) => (
  <>
    <Header goBack={goBack} loading={loading} />
    {error && <NetworkError />}
    <div className={styles.FoodCourtLayout}>
      <div className={styles.foodcourtLeft}>{left}</div>
      <div className={styles.foodcourtRight}>{right}</div>
    </div>
  </>
);

export default FoodCourtLayout;
